<template>
  <div v-if="($route.name === pageName() && orderEdit || $route.name !== pageName()) && paymentList" class="new-order">
    <Rate
      v-if="(($route.query.tab === 'zgi' && config.hide_blocks.price.zgi && prices) || !config.hide_blocks.price[$route.query.tab]) && !isMobile"
      @changeCurrency="changeCurrency"
      :currency="currency" />

    <Tabs
      v-if="services"
      :tabs="tabs"
      :currency="currency"
      @changeCurrency="changeCurrency"
      :warning="true"
      :title="titleSet()"
      :orderCount="orderCount"
      :class="[
        {'tab--single': tabs.length === 1},
        {'tab--some': tabs.length === 2},
        'tab--new-order', 
      ]"
      :disabled="disableTab()">
      <NewOrderZgi
        v-if="configAccess.new_order_to_supplier.supplier_new_order_zgi"
        v-show="$route.query.tab === 'zgi'"
        @orderCountUpdate="orderCountUpdate"
        :draft="draft"
        :zgi="true"
        :currency="currency"
        :access="configAccess.new_order_to_supplier.supplier_new_order_zgi"
        :orderEditInfo="editInfoZgi()" />
      <NewOrderCut
        v-if="configAccess.new_order_to_supplier.supplier_new_order_opt"
        v-show="$route.query.tab === 'cut'"
        @orderCountUpdate="orderCountUpdate"
        :draft="draft"
        :cut="true"
        :currency="currency"
        :access="configAccess.new_order_to_supplier.supplier_new_order_opt"
        :orderEditInfo="editInfoCut()" />
      <NewOrderOpt
        v-if="paymentList && configAccess.new_order_to_supplier.supplier_new_order_opt"
        v-show="$route.query.tab === 'opt'"
        @orderCountUpdate="orderCountUpdate"
        :draft="draft"
        :opt="true"
        :currency="currency"
        :access="configAccess.new_order_to_supplier.supplier_new_order_opt"
        :orderEditInfo="editInfoOpt()" />
    </Tabs>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations, mapGetters } from "vuex";
import { PAGES } from "@/constants/pages";
import { NEW_ORDER_TAB } from "@/store/modules/account/variables";
import { storageCurrency } from "@/utils/currency";

export default {
  name: "NewOrder",

  components: {
    Rate: () => import('@/components/rate'),
    NewOrderZgi: () => import('./NewOrderZgi.vue'),
    NewOrderOpt: () => import('./NewOrderOpt.vue'),
    NewOrderCut: () => import('./NewOrderCut.vue'),
    Tabs: () => import('@/pages/account/components/Tabs'),
  },

  data: () => ({
    currency: false,
    path: '',
    orderCount: {
      zgi: 0,
      cut: 0,
      opt: 0,
    },
    draft: {
      popup: false,
      zgi: null,
      cut: null,
      opt: null,
    },
    tabs: [
      {
        name: NEW_ORDER_TAB.zgi.title,
        path: NEW_ORDER_TAB.zgi.path,
      },
      {
        name: NEW_ORDER_TAB.cut.title,
        path: NEW_ORDER_TAB.cut.path,
      },
      {
        name: NEW_ORDER_TAB.opt.title,
        path: NEW_ORDER_TAB.opt.path,
      },
    ],
  }),

  metaInfo() {
    return {
      title: `Новый заказ поставщику - Личный кабинет дилера - ${this.getDealerName}`,
    }
  },

  watch:{
    '$route' (to, from) {
      this.draft.popup = false;
      const item = this.draft[to.query.tab]
      if (!item) {
        this.orderDraft();
      }
    }
  },

  computed: {
    ...mapState({
      orderEdit: state => state.account.newOrder.orderEdit,
      configAccess: state => state.user.configAccess,
      paymentList: state => state.account.newOrder.payment,
      services: state => state.account.services,
      config: state => state.user.config,
      companies: state => state.user.companies,
      orderCopy: state => state.account.newOrder.orderCopy,
      prices: state => state.account.newOrder.prices,
    }),

    ...mapGetters('user', [
      'getDealerName',
    ]),
  },

  methods: {
    ...mapActions('account/newOrder', [
      'setModelsZgi',
      'setModelsCut',
      'setModelsOpt',
      'loadConfigCut',
      'orderEditLoad',
      'paymentLoad',
      'getDraft',
    ]),

    ...mapMutations('account/newOrder', [
      'updateCopyOrder',
    ]),

    ...mapActions('account', [
      'servicesLoad',
    ]),

    changeCurrency(val) {
      storageCurrency.set(val);
      this.currency = val;
    },

    orderCountUpdate(type, number) {
      this.orderCount[type] = number;
    },

    titleSet() {
      const orderEdit = this.orderEdit;
      if (orderEdit) {
        return `Редактирование заказа №${orderEdit.number}`;
      } else {
        return 'Новый заказ поставщику';
      }
    },

    disableTab() {
      if (this.orderEdit) {
        return true;
      } else {
        return false;
      }
    },

    pathUpdate() {
      this.path = null;
    },

    pageName() {
      return PAGES.wholesale.name;
    },

    editInfoZgi() {
      return this.orderEdit?.content_type === NEW_ORDER_TAB.zgi.path.toUpperCase() ? this.orderEdit : null;
    },

    editInfoCut() {
      return this.orderEdit?.content_type === NEW_ORDER_TAB.cut.path.toUpperCase() ? this.orderEdit : null;
    },

    editInfoOpt() {
      return this.orderEdit?.content_type === NEW_ORDER_TAB.opt.path.toUpperCase() ? this.orderEdit : null;
    },

    async fetchData() {
      await Promise.all([
        this.setModelsZgi()
          .then(res => {
            if (!res.length) {
              this.deleteTab('zgi');
            }
          }),
        this.setModelsCut()
          .then(res => {
            if (!res.length) {
              this.deleteTab('cut');
            }
          }),
        this.setModelsOpt()
          .then(res => {
            if (!res.length) {
              this.deleteTab('opt');
            }
          }),
      ]).then(res => {
        const query = this.$route.query.tab;
        const tabs = this.tabs.map(el => el.path);
        if (!tabs.includes(query)) {
          this.$router.push({
            query: {
              tab:  this.tabs[0].path,
            }
          });
        }
        this.togglePreload();
      });
    },

    orderDraft() {
      if (this.$route.name !== 'wholesale-orders-edit' && this.$route.query.tab && !this.orderCopy.data) {
        this.getDraft(this.$route.query.tab)
          .then(res => {
            if (res.length > 0) {
              this.draft[this.$route.query.tab] = res;
              this.draft.popup = true;
            }
          })
      }
    },

    deleteTab(name) {
      const index = this.tabs.findIndex(el => el.name === NEW_ORDER_TAB[name].title);

      if (index !== -1) {
        this.tabs.splice(index, 1);
      }
    }
  },

  created() {
    if (!this.configAccess.new_order_to_supplier.supplier_new_order_zgi) {
      this.deleteTab('zgi');
    }
    if (!this.configAccess.new_order_to_supplier.supplier_new_order_opt) {
      this.deleteTab('cut');
    }
    if (!this.configAccess.new_order_to_supplier.supplier_new_order_opt) {
      this.deleteTab('opt');
    }

    this.togglePreload();
    if (this.$route.name === 'wholesale-orders-edit') {
      this.orderEditLoad({
        'uuid': this.$route.params.uuid,
      }).then(res => {
        if (!this.orderEdit.is_edit) {
          this.updatePopup(true, 'PopupEditWarning');
        }
      })
    }
    this.loadConfigCut();
    this.paymentLoad();
    this.servicesLoad();
    this.fetchData();

    if (!this.companies || (this.companies && !this.companies.length)) {
      this.updatePopup(true, 'PopupEmployeeWarning');
    }

    const currency = storageCurrency.get();

    if (typeof currency === "boolean") {
      this.currency = currency;
    }

    this.orderDraft();
  },

  beforeDestroy() {
    this.updateCopyOrder({
      'path': null,
      'data': null,
    })
  }
}
</script>

<style scoped lang="scss">
.new-order {
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
}
</style>
